module.exports = __webpack_public_path__ + "img/圣嘉新.c91c5e8.png";